export default __webpack_public_path__ + "static/media/logo-footer.4e4a3e32.svg";